import { render, staticRenderFns } from "./test-upload.vue?vue&type=template&id=70cf751a&scoped=true&"
import script from "./test-upload.vue?vue&type=script&lang=js&"
export * from "./test-upload.vue?vue&type=script&lang=js&"
import style0 from "./test-upload.vue?vue&type=style&index=0&id=70cf751a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cf751a",
  null
  
)

export default component.exports